import { create } from 'zustand';
import { SystemConfigItem } from 'api/services/systemConfigService';

interface SystemConfigState {
  config: Record<string, string>;
  sessionTimeout: number;        // minutos
  sessionWarningBefore: number;  // minutos antes del vencimiento para mostrar el aviso
  redirectTimeoutSessionExpired: number;  // segundos
  /** Uso interno: carga parámetros activos desde /sys-config/app-params */
  setAppParams: (items: { name: string; value: string }[]) => void;
  /** Uso admin: carga lista completa desde /sys-config (requiere permiso) */
  setConfig: (items: SystemConfigItem[]) => void;
}

function applyParams(params: Record<string, string>) {
  return {
    config: params,
    sessionTimeout: params['session_timeout'] ? parseInt(params['session_timeout'], 10) : 20,
    sessionWarningBefore: params['session_warning_before'] ? parseInt(params['session_warning_before'], 10) : 5,
    redirectTimeoutSessionExpired: params['redirect_timeout_session_expired']
      ? parseInt(params['redirect_timeout_session_expired'], 10)
      : 10,
  };
}

export const useSystemConfigStore = create<SystemConfigState>((set) => ({
  config: {},
  sessionTimeout: 20,
  sessionWarningBefore: 5,
  redirectTimeoutSessionExpired: 10,
  setAppParams: (items) => {
    const params = Object.fromEntries(items.map((i) => [i.name, i.value]));
    set(applyParams(params));
  },
  setConfig: (items) => {
    const params = Object.fromEntries(
      items.filter((i) => i.idStatus === 1).map((i) => [i.name, i.value])
    );
    set(applyParams(params));
  },
}));
